const customerKey = 'demo'

// const server = '192.168.178.25'
const server = 'localhost'

export const environment = {
  production: false,

  serverUri: `http://${server}:3000`,
  customerKey,
  graphQlUri: `http://${server}:3000/graphql`,
  frontendUrl: 'http://localhost:4200',

  // tracking options
  trackingEnabled: true,
  gtmId: 'GTM-WLTK8QM',
  gtmAuth: 'pfddzqXpNt_8GCSQE54aKw',
  gtmEnv: undefined, // 'env-2',

  // rollbar options
  rollbarEnabled: false,
  rollbarClientToken: 'xxxx',
  stage: 'dev',
  version: `local`,

  // Wizart
  wizartRenderApiToken: 'vX0t5G75oAkUuMIGtLFJv3uf0XgTWxdgdCB1lypEGIqNY58To7BKxW44r2MA',
};
